module.exports = __webpack_public_path__ + "img/xls_csv_type.16082649.jpg";